import Vue from 'vue'
import Router from 'vue-router'

// Pages
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import Main from '@/pages/Dashboard/Main'
import Data from '@/pages/Dashboard/Data'
import Contact from '@/pages/Dashboard/Contact'
import Visit from '@/pages/Dashboard/Visit'
import Resetpass from '@/pages/Resetpass'

Vue.use(Router)

export default new Router({
  mode: 'history',
  history: true,
  linkActiveClass: 'uk-active',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login/:id?/:hash([a-zA-Z0-9]+)?',
      name: 'LoginHash',
      component: Login
    },
    {
      path: '/resetpass/:hash([a-zA-Z0-9]+)',
      name: 'Resetpass',
      component: Resetpass
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      redirect: '/dashboard/main',
      component: Dashboard,
      children: [
        { path: 'main', name: 'main', component: Main, meta: { name: 'Moje wizyty' } },
        { path: 'data', name: 'data', component: Data, meta: { name: 'Moje dane' } },
        { path: 'contact', name: 'contact', component: Contact, meta: { name: 'Kontakt z kliniką' } },
        { path: 'visit/:visitId,:status,:ankieta,:doctor,:data,:position,:reason,:adres1,:adres2,:information,:type,:cena', name: 'visit', component: Visit, meta: { name: 'Widok wizyty' } },
        { path: '*', name: 'page-not-found', redirect: 'main' }
      ]
    },
    {
      path: '*',
      redirect: '/dashboard/main'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js